import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Collection from './components/Engineers';
import Stats from './components/Stats';
import Object from './components/Engineer';
import Wos_Worked from './components/Wos_Worked'
import WeeklyEstimates from './components/WeeklyEstimates'
import ScheduleApprovals from './components/ScheduleApprovals'
import DailyEta from './components/DailyEta'

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */

export default ({match,regions,roles,currentFE,user,location}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection regions={regions} roles={roles} currentFE={currentFE}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/stats`}>
				<Stats regions={regions} roles={roles} currentFE={currentFE} user={user}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/worked`}>
				<Wos_Worked regions={regions} roles={roles} currentFE={currentFE} user={user}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/weekly_estimates`}>
				<WeeklyEstimates regions={regions} roles={roles} currentFE={currentFE} user={user}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/approvals`}>
				<ScheduleApprovals regions={regions} roles={roles} user={user} initialDate={location?.state?.initialDate}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/daily_eta`}>
				<DailyEta regions={regions} roles={roles} user={user}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/:id`}>
				<Object regions={regions} baseUrl={match.url}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`} />
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
